import React from 'react';

/* Mark 6Q, approved 2026-09-21: six teal tree outlines standing behind the word,
   one amber tree clear of it to the right. Inline SVG on the approved 222x110
   viewBox — seven curved outlines at three stroke weights cannot be drawn as
   spans, so this trades the old DOM mark's free recolour for the real drawing.
   Strokes take the theme accents (currentColor in mono); the word stays a live
   text node, never outlines, so it keeps matching Geist as the font updates. */

const TREE = 'M60 12 C63 40 68 52 82 64 C74 63 69 62 64 58 C69 84 76 102 92 118 C83 116 77 114 72 110 C78 142 87 162 102 182 C91 180 85 178 80 174 C86 208 96 230 112 252 L66 252 L66 288 L54 288 L54 252 L8 252 C24 230 34 208 40 174 C35 178 29 180 18 182 C33 162 42 142 48 110 C43 114 37 116 28 118 C44 102 51 84 56 58 C51 62 46 63 38 64 C52 52 57 40 60 12 Z';

/* x, scale, stroke-width, stroke-opacity — straight off the approved drawing. */
const STAND = [[20,0.3,10,0.26],[42,0.25,11,0.2],[64,0.23,11,0.42],[86,0.2,13.5,0.2],[108,0.28,10,0.32],[130,0.26,10.4,0.2]];
const SIGNAL = [200, 0.32, 7.6];

/* Fixed aspect. Every dimension is a ratio of the font size: the word is set at
   58px in the viewBox, so size 16 draws the lockup at 61.2 x 30.3 CSS px.
   Optical minimum is size 16 — below it the icon mark replaces the lockup. All
   seven trees draw at every size; there is no reduced variant. */
const W = 222 / 58, H = 110 / 58;

export function Wordmark({ size = 16, mark = true, tone = 'default', className = '', ...rest }) {
  const mono = tone === 'mono';
  const word = mono ? 'currentColor' : 'var(--text-strong)';

  /* Word alone: type, not drawing — set as text so it hints and selects. */
  if (!mark) {
    return (
      <span
        className={className}
        style={{
          fontFamily: 'var(--font-sans)', fontSize: size, fontWeight: 600,
          letterSpacing: '-0.031em', lineHeight: 1, color: word
        }}
        {...rest}
      >
        Spruce
      </span>
    );
  }

  return (
    <svg
      className={className}
      viewBox="0 0 222 110"
      width={size * W}
      height={size * H}
      role="img"
      aria-label="Spruce"
      focusable="false"
      style={{ display: 'inline-block', verticalAlign: 'middle', flex: 'none' }}
      {...rest}
    >
      <g fill="none" strokeLinejoin="round" stroke={mono ? 'currentColor' : 'var(--accent-data)'}>
        {STAND.map(([x, s, w, o], i) => (
          <g key={i} transform={`translate(${x},94) scale(${s}) translate(-60,-288)`} strokeWidth={w} strokeOpacity={mono ? 0.45 : o}>
            <path d={TREE} />
          </g>
        ))}
        <g
          transform={`translate(${SIGNAL[0]},94) scale(${SIGNAL[1]}) translate(-60,-288)`}
          strokeWidth={SIGNAL[2]}
          stroke={mono ? 'currentColor' : 'var(--accent-signal)'}
          strokeOpacity={mono ? 1 : 0.72}
        >
          <path d={TREE} />
        </g>
      </g>
      <text x="10" y="92" fontSize="58" fontWeight="600" letterSpacing="-1.8" fill={word} style={{ fontFamily: 'var(--font-sans)' }}>
        Spruce
      </text>
    </svg>
  );
}
